/*
* Removing Trailing Slashes
*/
export default defineNuxtRouteMiddleware((to) => {
  if (to.path.endsWith('/') && to.path !== '/') {
    const path = to.path.slice(0, -1)

    return navigateTo(path, { redirectCode: 301 })
  }
})